const GRIEVANCE_OFFICER = {
  name: 'Nitin Khot',
  email: 'contact@marathivadhuvarsuchak.com',
  phone: '+91 8591407273 / 9326013123',
  address:
    'Panchavati CHS, A3 H Wing - 15, Marol Maroshi Road, Vijay Nagar, Andheri (E), Maharashtra, Mumbai, 400059, India.',
  hours: 'Call us for any inquiry or information between 10.30 AM to 6 PM on Monday To Saturday.',
} as const;

export default function GrievanceOfficerContact() {
  return (
    <div className="mt-12">
      <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-6">
        Grievance Officer Contact Details
      </h2>
      <p className="text-gray-700 mb-6 text-lg leading-relaxed">
        As per the Govt of India Information Technology Act 2010 and the rules made under it, the name and contact details of the Grievance Officer are given below:
      </p>
      <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 mb-8">
        <div className="content-prose-sm contact-info">
          <p className="text-gray-700">
            <strong>Contact Person:</strong> {GRIEVANCE_OFFICER.name}
          </p>
          <p className="text-gray-700">
            <strong>Email:</strong> {GRIEVANCE_OFFICER.email}
          </p>
          <p className="text-gray-700">
            <strong>Phone:</strong> {GRIEVANCE_OFFICER.phone}
          </p>
          <p className="text-gray-700">
            <strong>Address:</strong> {GRIEVANCE_OFFICER.address}
          </p>
          <p className="text-gray-700 mt-4 font-medium">{GRIEVANCE_OFFICER.hours}</p>
        </div>
      </div>
    </div>
  );
}
